import React from 'react';
import {PolIcon} from "components/PolIcon/policon";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useGlobalSearch from "./hooks/useGlobalSearch";
import "./GlobalSearch.scss";

export default function GlobalSearch() {
    const {t} = usePolTranslation();
    const {
        search,
        setSearch,
        isSearchInputOpen,
        setIsSearchInputOpen,
        globalSearchInput,
        handleSubmit,
        handleIconClick
    } = useGlobalSearch();

    return (
        <form className={`globalSearch ${isSearchInputOpen ? "globalSearch--extended" : ""}`} onSubmit={handleSubmit}>
            <input
                ref={globalSearchInput}
                className={`globalSearch__input ${isSearchInputOpen ? "" : 'input__close'}`}
                value={search}
                placeholder={t('default_value_search')}
                onChange={(e) => setSearch(e.target.value)}
                onBlur={() => !search && setIsSearchInputOpen(false)}
            />
            <button
                type="submit"
                title={t('make_global_search')}
                onClick={handleIconClick}
            >
                <PolIcon icon="search"/>
            </button>
        </form>
    );
}
